import get from 'lodash/get';
import types from './types';

import data from './data';

const initialState = {
  ...data,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CRE_TEAM_LIST_SUCCEEDED:
      return {
        ...state,
        leadership: {
          ...state.leadership,
          items: get(action, 'data.result[0].leadership'),
        },
      };

    default:
      return {
        ...state,
      };
  }
};
